import * as React from 'react';
import { connect } from 'react-redux';
import { Route } from "react-router";
import { hideMobileProfile } from '../../actions/profileActions';
import { Card, Accordion } from 'react-bootstrap';
import './LifeInsuranceCover.css';
import { DASHBOARD, LIFE_CHANGE_DEBIT_ORDER_DATE, LIFE_INSURANCE, LIFE_INSURANCE_CHANGE_DEBIT_ORDER_DATE_DEBICHECK_VALIDATE, LIFE_UPDATE_BENEFICIARIES } from '../../routes/routes';
import KPBreadCrumb from '../KPBreadCrumb/KPBreadCrumb';
import { navigateTo } from '../../actions/navigationActions';
import { showRequestCancelLifePolicy } from "../../actions/modalActions";
import { ChangeDebitOrderDate } from "../BankingDetails/ChangeDebitOrderDate";
import { postToController } from "../../actions/apiActions";
import { updateDebitOrderDate } from "../../actions/lifePolicyActions";
import { DebicheckValidate } from "../BankingDetails/DebicheckValidate";

class LifeChangeDebitOrderDate extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
            updateReminderDismissed: false,
            selectedBenefit: {},
            isInEdit: false,
            newDebitOrderDateValue: '',
            newDebitOrderDateText: '',
            showDebicheck: false,
        }
        
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handlePersistChangeDebitOrderDate = this.handlePersistChangeDebitOrderDate.bind(this);
        this.getBankInfo = this.getBankInfo.bind(this);
        this.handleDebicheck = this.handleDebicheck.bind(this);
    }
    
    handleRedirect(destination) {
        this.props.redirectTo(destination);
    }
    
    componentDidMount() {
        this.getBankInfo();
        const activeBenefitId = this.props.lifePolicy.policy.activeBenefitId;
        const mainBenefit = this.props.lifePolicy.policy.benefits.filter((ben) => ben.id === activeBenefitId)[0];

        this.setState({
            selectedBenefit: mainBenefit,
        });

        this.props.dispatchHideProfile();
    }

    async handleDebicheck(value: any, text: any) {

        this.setState({
            newDebitOrderDateValue: value,
            newDebitOrderDateText: text,
        });

        if (this.props.lifePolicy.policy?.paymentType?.toLowerCase() != 'debicheck') {
            this.handlePersistChangeDebitOrderDate(null, value, text);
        } else {
            this.setState({
                showDebicheck: true,
            });
        }


    }
    
    async handlePersistChangeDebitOrderDate(e: any, value = null, text = null) {
        if (value == null) {
            value = this.state.newDebitOrderDateValue;
        }
        if (text == null) {
            text = this.state.newDebitOrderDateText;
        }

        this.props.emitHandlePersistChangeDebitOrderDate();
        this.props.dispatchPersistDebitOrderDate(value, text);

        this.setState({
            showDebicheck: false,
        });
    }
    
    async getBankInfo() {
        await this.setState({
            bankInfoLoading: true,
        });
        try {
            await postToController(this.props.dispatch, 'GetLifeBankInfo', JSON.stringify({})).then(async (response) => {
                await this.setState({
                    debitDayList: response.debitOrderDateList,
                });
                return true;
            });
        } finally {
            await this.setState({
                bankInfoLoading: false,
            });
        }
    }

    public render() {
        return (
            <>
            { !this.state.showDebicheck &&
                <ChangeDebitOrderDate
                    debitOrderDateList={this.state.debitDayList}
                    debitOrderDate={this.props.lifePolicy.policy.debitOrderDateFriendly}
                    emitHandleChangeDebitOrderDate={this.handleDebicheck}
                ></ChangeDebitOrderDate>
                ||
                <DebicheckValidate
                    emitHandleValidate={this.handlePersistChangeDebitOrderDate}
                    title="Change debit order date"
                    error={this.props.lifePolicy.metadata?.bankingDetails?.error}
                    success={this.props.lifePolicy.metadata?.bankingDetails?.success}
                ></DebicheckValidate>
            }
            </>
        )
    }

}
const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        lifePolicy: state.lifePolicy,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchHideProfile: () => dispatch(hideMobileProfile()),
        showRequestCancelLifePolicy: () => dispatch(showRequestCancelLifePolicy()),
        dispatchPersistDebitOrderDate: (date, text) => dispatch(updateDebitOrderDate(date, text)),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LifeChangeDebitOrderDate);
